const toggleAccordion = require('./search/toggleAccordion').toggleAccordionItem;

$(document).ready(() => {
    $('.js-refine-accordion-button').on('click', toggleAccordion);
});
